/**Routing values. */
export const navigation = {
    default: "*" as const,
    frontPage: "/" as const,
    gamePage: "/game" as const,
    testerPage: "/tester" as const,
    settingsPage: "/settings" as const,
    howtoPage: "/howto" as const
};